import { useRecoilValue } from "recoil";
import payloadState from "../../recoil/payloadState";

export default function BottomSection() {
  const payload = useRecoilValue(payloadState);
  console.log('payload', payload);
  
  const logo = payload?.client_data.checkout_configs.branding_configs.logo;

  return (
    <div className="mb-4 flex w-full justify-center ">
      {logo && (
        <img
          className="h-12 w-24 object-contain"
          src={logo}
          alt=""
        />
      )}
    </div>
  );
}
